import React from "react"

import { ButtonElement } from "@front-shared/elements/button.element"
import { PrimaryText } from "@front-shared/elements/primaryText.element"

import magicWandIcon from "@front-shared/assets/images/icons/magic-wand-dark.svg"

export const BulkResultsSmartScanBannerComponent: React.FunctionComponent<
    IBulkResultsSmartScanBannerComponentProps
> = props => {
    const credits = props.inactiveCount * props.creditsPerCheck
    const isRecovered = !props.isRunning && props.recoveredCount > 0

    return (
        <div
            className={`
                mt-[24px] flex items-center justify-between gap-[16px] rounded-[16px] px-[24px] py-[20px]
                md:flex-col md:items-start
                ${isRecovered ? "bg-brand-warmLight025" : "bg-brand-whitePurple"}
            `}
        >
            <div className="flex items-start gap-[16px]">
                <img
                    src={magicWandIcon}
                    alt="SmartScan"
                    className="mt-[4px] h-[24px] w-[24px]"
                />

                {props.isRunning ? (
                    <PrimaryText>
                        <span className="text-bold">
                            Running SmartScan on {props.scanningCount} patient
                            {props.scanningCount === 1 ? "" : "s"}
                        </span>
                        . Results update below as each patient comes back.
                    </PrimaryText>
                ) : isRecovered ? (
                    <PrimaryText>
                        <span className="text-bold">
                            SmartScan recovered active coverage for{" "}
                            {props.recoveredCount} patient
                            {props.recoveredCount === 1 ? "" : "s"}
                        </span>
                        .{" "}
                        {props.inactiveCount
                            ? `${props.inactiveCount} still came back inactive.`
                            : "Updated results are marked in the table below."}
                    </PrimaryText>
                ) : (
                    <PrimaryText>
                        <span className="text-bold">
                            {props.inactiveCount} patient
                            {props.inactiveCount === 1 ? "" : "s"} returned
                            inactive policies
                        </span>
                        . SmartScan can search for their active coverage using
                        the same demographics you already submitted.
                    </PrimaryText>
                )}
            </div>

            {props.inactiveCount ? (
                <div className="flex-shrink-0 text-right">
                    <ButtonElement
                        type="primary"
                        htmlType="button"
                        size="large"
                        isLoading={props.isRunning}
                        disabled={props.isRunning}
                        label={`${
                            isRecovered
                                ? "Run SmartScan again on"
                                : "Run SmartScan on"
                        } ${props.inactiveCount} patient${
                            props.inactiveCount === 1 ? "" : "s"
                        }`}
                        onClick={props.onRunSmartScan}
                    />

                    <PrimaryText className="mt-[8px] opacity-60">
                        {credits} credit{credits === 1 ? "" : "s"} ·{" "}
                        {props.creditsPerCheck} credits per check
                    </PrimaryText>
                </div>
            ) : null}
        </div>
    )
}

interface IBulkResultsSmartScanBannerComponentProps {
    inactiveCount: number
    creditsPerCheck: number
    recoveredCount: number
    isRunning: boolean
    scanningCount: number
    onRunSmartScan: () => void
}
